export const SET_BROWSE_BY = 'SET.BROWSE.BY';
export const SET_BROWSE_BY_FACET = 'SET.BROWSE.BY.FACET';
export const SET_SORTS = 'SET.SORTS';
export const SET_LOAD_MORE = 'SET.LOAD.MORE';
export const SET_POPSTATE = 'SET.POPSTATE';
export const SET_FIRST_QUERY = 'SET.FIRST.QUERY';
export const SET_FILTERS = 'SET.FILTERS';
export const APPLY_FILTER = 'APPLY.FILTER';
export const APPLY_SORT = 'APPLY.SORT';
export const CLEAR_FILTERS = 'CLEAR.FILTERS';
